const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarsLogoMinBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 224 223.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m105.02,0c-22.14,1.22-41.7,8.34-59.44,21.63l2.36,2.81,20.19,24.06c10.66-7.39,23.26-12.15,36.89-13.38V0Z",
    style: {
      fill: "#47b7e4",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.89,30.61C18.71,45.77,8.31,63.8,3.26,85.39l34.39,6.06c3.58-13.04,10.48-24.7,19.76-34l-22.53-26.84Z",
    style: {
      fill: "#5567af",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.2,105.2L.83,99.14c-2.64,22.01.97,42.51,10.98,62.29l30.09-17.37c-4.5-9.79-7.02-20.67-7.02-32.14,0-2.27.12-4.5.31-6.72Z",
    style: {
      fill: "#8c62a8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.86,156.16l-30.06,17.36c12.13,18.56,28.07,31.94,48.45,40.66l11.83-32.52c-12.16-5.75-22.57-14.59-30.23-25.5Z",
    style: {
      fill: "#ba68a9",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.2,186.45l-11.83,32.51c21.37,6.5,41.89,6.5,63.26,0l-11.83-32.5c-6.32,1.67-12.95,2.58-19.8,2.58s-13.48-.9-19.8-2.58Z",
    style: {
      fill: "#ed4999",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.91,181.66l11.83,32.52c20.38-8.72,36.33-22.1,48.46-40.66l-30.06-17.36c-7.66,10.91-18.07,19.75-30.23,25.5Z",
    style: {
      fill: "#ec1c24",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.09,144.06l30.09,17.37c10.01-19.78,13.62-40.28,10.98-62.29l-34.36,6.06c.19,2.22.31,4.46.31,6.72,0,11.47-2.53,22.35-7.02,32.14Z",
    style: {
      fill: "#f9a51f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.74,85.39c-5.05-21.59-15.45-39.61-31.63-54.78l-3.74,4.45-18.79,22.39c9.28,9.3,16.18,20.96,19.76,34l34.39-6.06Z",
    style: {
      fill: "#fdd900",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.45,31.14l7.97-9.5C160.68,8.34,141.12,1.22,118.98,0v35.13c13.63,1.22,26.23,5.99,36.89,13.38l14.58-17.37Z",
    style: {
      fill: "#68bd62",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.6,70.94h20.1l13.3,40.49,13.3-40.49h20.1l7.92,81.94h-21.1l-4.75-39.04-8.24,29.16h-14.31l-8.39-29.52-4.75,39.41h-21.09l7.92-81.95Z",
    style: {
      fill: "#010101",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarsLogoMinBlack);
export default __webpack_public_path__ + "static/media/mars_logo_min_black.36d1067e07d038fa2add86421742ef41.svg";
export { ForwardRef as ReactComponent };